<template>
  <div class="title-bar">
    <div class="title-bar__icon">
      <slot name="icon" />
    </div>
    <div class="title-bar__text-wrap">
      <span class="title-bar__text">{{ title }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
  interface Props {
    title: string;
  }

  defineProps<Props>();
</script>

<style lang="scss" scoped>
  @use '@/assets/scss/variables' as vars;

  .title-bar {
    display: flex;
    align-items: center;
    gap: 0.7463vw;
    width: 100%;
    height: 100%;
    @media (max-width: vars.$sm) {
      gap: 10px;
    }
    .title-bar__icon > img {
      width: 2.6866vw;
      @media (max-width: vars.$sm) {
        width: 24px;
      }
    }
    .title-bar__text-wrap {
      position: relative;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      .title-bar__text {
        font-size: 2.0896vw;
        font-weight: 700;
        @media (max-width: vars.$sm) {
          font-size: 16px;
        }
        &:after {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 14px;
          border-bottom: 0.7463vw solid var(--brand-primary);
          opacity: 0.2;
          @media (max-width: vars.$md) {
            border-bottom-width: 10px;
          }
        }
      }
    }
  }

  .dark-theme,
  .dark-gray-theme {
    .title-bar {
      .title-bar__text:after {
        border-bottom: 0.7463vw solid #ffff00;
        opacity: 0.4;
      }
    }
  }
</style>
